import { RefreshCw } from "lucide-react";
import {
  allTimeAdminDateRange,
  defaultAdminDateRange,
  todayInSaoPaulo,
} from "../../config/admin";
import DateInput from "./DateInput";

const PRESETS = [
  { id: "7", label: "7 dias", days: 7 },
  { id: "30", label: "30 dias", days: 30 },
  { id: "90", label: "90 dias", days: 90 },
  { id: "365", label: "1 ano", days: 365 },
  { id: "all", label: "Todo o período" },
];

export default function DateRangeBar({
  startDate,
  endDate,
  onChange,
  onApply,
  onReload,
  loading,
}) {
  const applyRange = (range) => {
    onChange(range);
    onApply(range);
  };

  const applyPreset = (preset) => {
    if (preset.id === "all") {
      applyRange(allTimeAdminDateRange());
      return;
    }
    applyRange(defaultAdminDateRange(preset.days));
  };

  const handleReload = () => {
    onReload?.({ startDate, endDate });
  };

  return (
    <form
      className="admin-controls"
      onSubmit={(event) => {
        event.preventDefault();
        handleReload();
      }}
    >
      <div className="admin-control">
        <label className="admin-control-label" htmlFor="admin-start-date">
          Data inicial
        </label>
        <DateInput
          id="admin-start-date"
          value={startDate}
          max={endDate || todayInSaoPaulo()}
          onChange={(next) => onChange({ startDate: next, endDate })}
        />
      </div>
      <div className="admin-control">
        <label className="admin-control-label" htmlFor="admin-end-date">
          Data final
        </label>
        <DateInput
          id="admin-end-date"
          value={endDate}
          min={startDate}
          max={todayInSaoPaulo()}
          onChange={(next) => onChange({ startDate, endDate: next })}
        />
      </div>
      <div className="admin-preset-row">
        {PRESETS.map((preset) => (
          <button
            key={preset.id}
            type="button"
            className="admin-preset-btn"
            onClick={() => applyPreset(preset)}
            disabled={loading}
          >
            {preset.label}
          </button>
        ))}
      </div>
      {onReload && (
        <button
          type="submit"
          className="admin-secondary-btn admin-icon-only-btn"
          disabled={loading}
          aria-label="Recarregar"
          title="Recarregar"
        >
          <RefreshCw size={18} />
        </button>
      )}
    </form>
  );
}
